import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";
import { CAMPUS_CENTER } from "@/lib/constants";

const dotIcon = L.divIcon({
  className: "",
  html: '<div style="width:14px;height:14px;border-radius:9999px;background:hsl(13 65% 52%);border:3px solid #f6f3ea;box-shadow:0 0 0 2px hsl(13 65% 52%)"></div>',
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});

const TILES = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
const ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

const FitBounds = ({ animals }) => {
  const map = useMap();
  useEffect(() => {
    const pts = animals.filter((a) => a.lat != null && a.lng != null).map((a) => [a.lat, a.lng]);
    if (pts.length > 1) map.fitBounds(pts, { padding: [60, 60], maxZoom: 16 });
    else if (pts.length === 1) map.setView(pts[0], 16);
  }, [animals, map]);
  return null;
};

export const CampusMap = ({ animals = [], height = "520px" }) => (
  <div className="border border-border" data-testid="campus-map" style={{ height }}>
    <MapContainer center={CAMPUS_CENTER} zoom={15} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
      <TileLayer url={TILES} attribution={ATTR} />
      <FitBounds animals={animals} />
      {animals.map((a) =>
        a.lat != null && a.lng != null ? (
          <Marker key={a.post_id} position={[a.lat, a.lng]} icon={dotIcon}>
            <Popup>
              <div className="min-w-40">
                <p className="font-serif text-base font-semibold">{a.title}</p>
                <p className="text-xs italic text-stone-500">{a.species}</p>
                <Link
                  to={`/animal/${a.post_id}`}
                  data-testid={`map-popup-link-${a.post_id}`}
                  className="mt-1 inline-block text-xs font-bold uppercase tracking-widest text-[hsl(13,65%,52%)]"
                >
                  Read the entry
                </Link>
              </div>
            </Popup>
          </Marker>
        ) : null
      )}
    </MapContainer>
  </div>
);

const ClickHandler = ({ onPick }) => {
  useMapEvents({ click: (e) => onPick([e.latlng.lat, e.latlng.lng]) });
  return null;
};

export const LocationPicker = ({ position, onPick }) => (
  <div className="border border-border" data-testid="location-picker-map" style={{ height: "320px" }}>
    <MapContainer center={position || CAMPUS_CENTER} zoom={16} style={{ height: "100%", width: "100%" }}>
      <TileLayer url={TILES} attribution={ATTR} />
      <ClickHandler onPick={onPick} />
      {position && <Marker position={position} icon={dotIcon} />}
    </MapContainer>
  </div>
);
